import moment from 'moment';

import _t from 'i18n!nls/goal-setting';

export const GOAL_TYPE_COMPLETE_N_VIDEOS = 'GoalCompleteNVideos';
export const GOAL_TYPE_COMPLETE_N_ASSIGNMENTS = 'GoalCompleteNAssignments';
export const GOAL_TYPE_N_DAY_STREAK = 'GoalNDayStreak';
export const GOAL_TYPE_N_DAYS_A_WEEK = 'GoalNDaysAWeek';
export const GOAL_CREATION_PUSH_KEY = 'GoalSettingCreationPushKey';

export type GoalSettingState = 'editing' | 'creating' | 'default';

const momentDaysOfWeek = moment.weekdaysMin();

// Because Moment starts its weeks on Sunday but we start ours on Monday,
// We need to restructure the array to place Sunday last
// @ts-expect-error TS2769 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
const rearrangedDaysOfWeek = momentDaysOfWeek.slice(1).concat(momentDaysOfWeek[0]);

export type DayKey = 'mo' | 'tu' | 'we' | 'th' | 'fr' | 'sa' | 'su';
export const dayKeys = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

export const mapApiDayToMomentDay = {
  MONDAY: 'mo',
  TUESDAY: 'tu',
  WEDNESDAY: 'we',
  THURSDAY: 'th',
  FRIDAY: 'fr',
  SATURDAY: 'sa',
  SUNDAY: 'su',
} as const;

// Create a map mapping API day-of-week codes to their localized strings from Moment
export const DAYS_OF_WEEK: { [key in (typeof dayKeys)[number]]: string } = dayKeys.reduce(
  (acc, v, idx) => ({ ...acc, [v]: rearrangedDaysOfWeek[idx] }),
  {}
);

export const DAYS_OF_WEEK_LABELS: { [key in (typeof dayKeys)[number]]: string } = {
  mo: _t('Monday'),
  tu: _t('Tuesday'),
  we: _t('Wednesday'),
  th: _t('Thursday'),
  fr: _t('Friday'),
  sa: _t('Saturday'),
  su: _t('Sunday'),
};

/**
 * @description Type representing a day of the week, likely used for scheduling or progress tracking.
 */
export type DayOfWeek = keyof typeof DAYS_OF_WEEK;
